import ApiClient from "../../lib/apiClient";
import { Schema } from "./types";

class FieldSchemaApiClient {
  private _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  getSchema = async () => {
    return this._apiClient.get<Schema>(`field-schema`);
  };
  getSchemaV2 = async (route?: string) => {
    return this._apiClient.get<Schema>(route || `field-schema/v2`);
  };
}

export default FieldSchemaApiClient;
